import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { ALL_LICENSES_QUERY_KEY } from "./useExternalLicenses";

export interface UseDeleteLicenseProps {
  onSuccess?: () => void;
}

export interface UseDeleteLicenseMutationProps {
  licenseId: string;
}

export const useDeleteLicense = ({
  onSuccess,
}: UseDeleteLicenseProps): UseMutationResult<
  void,
  Error,
  UseDeleteLicenseMutationProps
> => {
  const licensingService = useLicensingServiceV1();
  const queryClient = useQueryClient();

  const { companyId } = useParams();

  return useMutation({
    mutationFn: async ({ licenseId }: UseDeleteLicenseMutationProps) => {
      return await licensingService.deleteLicenseById(licenseId);
    },
    onSuccess: (_, variables) => {
      void queryClient.setQueryData(
        [ALL_LICENSES_QUERY_KEY, companyId],
        (oldData: Licensing_V1.License[] | undefined) =>
          (oldData ?? []).filter(
            (license) => license.licenseId !== variables.licenseId,
          ),
      );
      void queryClient.invalidateQueries({
        queryKey: [ALL_LICENSES_QUERY_KEY],
      });
      onSuccess?.();
    },
  });
};
